/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface ParamsProps {
  idCorretorAtendimento: string | null;
  idLocalVenda: string | null | undefined;
  cep?: string | null;
  cidade?: string | null;
  bairro?: string | null;
  bairroComercial?: string | null;
}

export function useAtualizaUsuario(
  idTarefaLead: string,
  body: ParamsProps | null
) {
  const updateData = async () => {
    if (idTarefaLead === undefined) {
      return;
    }
    const USUARIO = `${leadsWebEnviroment}/app-web/tarefas-leads/concluir-tarefa-recepcionista/v1/${idTarefaLead}`;
    return await instance.put(USUARIO, body);
  };
  const query = useMutation({
    mutationFn: async () => await updateData(),
    mutationKey: ["concluir-tarefa-recepcionista"],
  });
  return query;
}
